import { useQuery } from "react-query";
import useGlobalContext from "./globalData";

export const useDeliverableContent = (
  skuDeliverableId: string | undefined,
  enabled: boolean
) => {
  const { skuDeliverableService } = useGlobalContext();

  return useQuery(
    ["deliverableContent", skuDeliverableId],
    () => skuDeliverableService.accessSkuDeliverable(skuDeliverableId!),
    {
      enabled: enabled && !!skuDeliverableId,
      staleTime: 0,
      cacheTime: 0,
    }
  );
};
